import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { AccountCircle, Info } from '@mui/icons-material';
import constants from '../../utils/constants.json';
import MenuIcon from '@mui/icons-material/Menu';
import { muistyles } from '../../utils/muistyles';
import { useNavigate } from 'react-router-dom';
import Popupdialog from '../../components/popupdialog';
import Loadingspinner from '../../components/Loadingspinner';
import { useDispatch, useSelector } from 'react-redux';
import { removeFromStore } from '../../utils/fn';
import { removeUser } from '../../store/user';

export default function AccountMenu({ onshowlogin, onshowsignup, loggedIn}) {
    const dispatch = useDispatch();
    const webSettings = useSelector((state) => state.webSettings.data);
    const navigate = useNavigate()
    const [loading, setloading] = useState(false);
    const [showlogout, setshowlogout] = useState(false);

    const fullName = webSettings.FULL_NAME;
    const firstname = fullName?.split(' ')[0];

    const [anchorEl, setAnchorEl] = React.useState('')
    const open = Boolean(anchorEl);
    const handleClick = (e) => {
        setAnchorEl(e.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };


    //logout from site
    const onlogout = () => {
        setshowlogout(false)
        setloading(true)
        setTimeout(() => {
            setloading(false)
            // logoutuser()
            removeFromStore(constants.USER_PROFILE);
            dispatch(removeUser(''));
            navigate("/", { replace: true })
        }, 3000);
    }

   


    return (
        <React.Fragment>
            {
                showlogout &&
                <Popupdialog
                    toptext={"Confirm exit!"}
                    question={"Are you sure you want to logout from this platform?"}
                    oncancel={() => setshowlogout(false)}
                    onsuccess={onlogout}
                    successtext={"Logout"} />
            }
            {loading && <Loadingspinner />}
            <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                <Tooltip title="Account">
                    <IconButton
                        onClick={handleClick}
                        size="small"
                        sx={{ ml: 2, color: webSettings.NAVBAR_TXT_COLOR }}
                        aria-controls={open ? 'account-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? 'true' : undefined}
                    >
                        <MenuIcon /><AccountCircle fontSize='large' />
                    </IconButton>
                </Tooltip>
            </Box>
            <Menu
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        width: '300px',
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&:before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
                <div style={{ padding: 10 }}>
                    <div style={{ display: 'flex' }}>
                        <img alt='logo' className='menuicon' src={webSettings.WEB_SITE_LOGO} />
                        <div>
                            <div style={{ fontWeight: "bold" }}>Explore {firstname}</div>
                            <div style={{ fontSize: 12 }}>Discover a wide range of high-quality products at {webSettings.FULL_NAME?.toLowerCase()}.</div>
                        </div>
                    </div>
                </div>
                <Divider />
                <MenuItem sx={muistyles.accountmenulink} onClick={() => {
                    navigate('/help')
                    handleClose()
                }}>
                    Help & Support
                </MenuItem>
                {!loggedIn &&
                    <MenuItem sx={muistyles.accountmenulink} onClick={() => {
                        handleClose()
                        onshowsignup()
                    }}>
                        Create Account
                    </MenuItem>}
                {!loggedIn &&
                    <MenuItem sx={muistyles.accountmenulink} onClick={() => {
                        handleClose()
                        onshowlogin()
                    }}>
                        Sign In
                    </MenuItem>}
                {loggedIn && <MenuItem sx={muistyles.accountmenulink} onClick={() => {
                    handleClose()
                    navigate("/account")
                }}>
                    My account
                </MenuItem>}
                {loggedIn && <MenuItem sx={muistyles.accountmenulink} onClick={() => {
                    handleClose()
                    setshowlogout(true)
                }}>
                    Logout
                </MenuItem>}

            </Menu>
        </React.Fragment>
    );
}